import { UnifiedGraftModelTypeKey } from '@/core/const/unifiedGraftModelTypeKeys.const'

export const GLOBAL_ENTRY_KIND = {
  FIELD: new Set([UnifiedGraftModelTypeKey.GLOBAL_FIELD]),
  METHOD: new Set([UnifiedGraftModelTypeKey.GLOBAL_METHOD, UnifiedGraftModelTypeKey.OVERLOADED_GLOBAL_METHOD]),
  TYPE: new Set([UnifiedGraftModelTypeKey.GLOBAL_TYPE]),
} as const
